import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { PlayerSelector } from '../player/PlayerSelector';
import { useState } from 'react';

const navigation = [
  {
    href: '/dashboard',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
      </svg>
    ),
    title: 'Dashboard',
    description: 'Overview & stats',
    color: 'blue'
  },
  {
    href: '/performance',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
      </svg>
    ),
    title: 'Performance',
    description: 'Weekly trends',
    color: 'blue'
  },
  {
    href: '/comparison',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'Compare',
    description: 'League averages',
    color: 'purple'
  },
  {
    href: '/standings',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
    title: 'Standings',
    description: 'Team rankings',
    color: 'green'
  },
  {
    href: '/team-summary',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    title: 'Team Summary',
    description: 'Team performance',
    color: 'teal'
  },
  {
    href: '/lanes',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'Lane Analysis',
    description: 'Performance by lane',
    color: 'orange'
  },
  {
    href: '/games',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Game Position',
    description: 'Game 1, 2, 3 analysis',
    color: 'pink'
  },
  {
    href: '/player-games',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    ),
    title: 'Game History',
    description: 'Complete breakdown',
    color: 'indigo'
  },
  {
    href: '/schedule',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Schedule',
    description: 'Weekly matchups',
    color: 'yellow'
  }
];

const colorClasses = {
  blue: 'hover:bg-blue-50 group-hover:bg-blue-200 bg-blue-100 text-blue-600',
  purple: 'hover:bg-purple-50 group-hover:bg-purple-200 bg-purple-100 text-purple-600',
  green: 'hover:bg-green-50 group-hover:bg-green-200 bg-green-100 text-green-600',
  teal: 'hover:bg-teal-50 group-hover:bg-teal-200 bg-teal-100 text-teal-600',
  orange: 'hover:bg-orange-50 group-hover:bg-orange-200 bg-orange-100 text-orange-600',
  pink: 'hover:bg-pink-50 group-hover:bg-pink-200 bg-pink-100 text-pink-600',
  indigo: 'hover:bg-indigo-50 group-hover:bg-indigo-200 bg-indigo-100 text-indigo-600',
  yellow: 'hover:bg-yellow-50 group-hover:bg-yellow-200 bg-yellow-100 text-yellow-600'
};

function SidebarContent({ onLinkClick }: { onLinkClick?: () => void }) {
  const location = useLocation();
  const { user, signOut } = useAuth();

  return (
    <div className="flex flex-col h-full">
      {/* Navigation Links */}
      <nav className="flex-1 p-4 space-y-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.href}
              to={item.href}
              onClick={onLinkClick}
              className={`flex items-center p-3 rounded-lg transition-colors group ${
                isActive 
                  ? `bg-${item.color}-50 border border-${item.color}-200` 
                  : `hover:bg-${item.color}-50`
              }`}
            >
              <div className={`rounded-lg p-2 mr-3 transition-colors ${colorClasses[item.color as keyof typeof colorClasses]}`}>
                {item.icon}
              </div>
              <div>
                <div className={`font-medium ${isActive ? `text-${item.color}-900` : 'text-gray-900'}`}>
                  {item.title}
                </div>
                <div className={`text-sm ${isActive ? `text-${item.color}-700` : 'text-gray-500'}`}>
                  {item.description}
                </div>
              </div>
            </Link>
          );
        })}
      </nav>

      {/* Sidebar Footer */}
      <div className="p-4 border-t border-gray-200 space-y-3 flex-shrink-0 relative">
        {/* Player Selector */}
        {user && (
          <div className="relative z-10">
            <div className="text-xs font-medium text-gray-500 mb-2">Current Player</div>
            <PlayerSelector />
          </div>
        )}

        {/* User Info & Settings */}
        {user && (
          <div className="space-y-2">
            {/* User Email */}
            <div className="text-xs text-gray-500 truncate" title={user.email}>
              {user.email}
            </div>
            
            {/* Settings Link */}
            <Link
              to="/settings"
              onClick={onLinkClick}
              className={`flex items-center p-3 rounded-lg transition-colors group w-full ${
                location.pathname === '/settings' 
                  ? 'bg-gray-50 border border-gray-200' 
                  : 'hover:bg-gray-50'
              }`}
            >
              <div className="bg-gray-100 rounded-lg p-2 mr-3 group-hover:bg-gray-200 transition-colors">
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div>
                <div className={`font-medium ${location.pathname === '/settings' ? 'text-gray-900' : 'text-gray-900'}`}>
                  Settings
                </div>
                <div className={`text-sm ${location.pathname === '/settings' ? 'text-gray-700' : 'text-gray-500'}`}>
                  Preferences
                </div>
              </div>
            </Link>

            {/* Sign Out Button */}
            <button
              onClick={() => {
                signOut();
                onLinkClick?.();
              }}
              className="w-full flex items-center p-3 rounded-lg hover:bg-red-50 transition-colors group"
            >
              <div className="bg-red-100 rounded-lg p-2 mr-3 group-hover:bg-red-200 transition-colors">
                <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </div>
              <div>
                <div className="font-medium text-gray-900">Sign Out</div>
                <div className="text-sm text-gray-500">End session</div>
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export function GlobalSidebar() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Don't show sidebar on homepage, login, or public pages
  const publicPages = ['/', '/login', '/privacy', '/terms', '/contact', '/unsubscribe', '/auth-redirect'];
  if (publicPages.includes(location.pathname)) {
    return null;
  }

  return (
    <>
      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Desktop sidebar */}
      <div className="w-64 bg-white shadow-lg border-r border-gray-200 h-screen-mobile fixed left-0 top-0 z-30 hidden lg:flex">
        <div className="flex-1 overflow-y-auto scrollbar-hide">
          <SidebarContent />
        </div>
      </div>

      {/* Mobile sidebar */}
      <div className={`lg:hidden w-64 bg-white shadow-lg border-r border-gray-200 h-screen-mobile fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out flex flex-col ${
        isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        {/* Scrollable content area - no header */}
        <div className="flex-1 overflow-y-auto scrollbar-hide">
          <SidebarContent onLinkClick={() => setIsMobileMenuOpen(false)} />
        </div>
      </div>

      {/* Global mobile hamburger button - positioned at bottom to avoid all headers */}
      <button
        onClick={() => setIsMobileMenuOpen(true)}
        className="lg:hidden fixed bottom-6 right-6 z-50 p-4 rounded-full bg-blue-600 text-white shadow-xl hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        aria-label="Open navigation menu"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </>
  );
}